<ng-container *transloco="let t; prefix: 'marketReports'">
  @if (campaign) {
    <div class="relative print:w-1/3">
      <div class="absolute left-2 top-2 z-10 print:hidden">
        <rma-property-status
          [isSold]="campaign.transactionType === marketReportTransactionTypeEnum.sales ? true : null"
          [isLeased]="campaign.transactionType === marketReportTransactionTypeEnum.leasing ? true : null"
        />
      </div>
      <rma-carousel class="aspect-[1.5]" [source]="images" />
    </div>
    <div class="flex w-full grow flex-col p-3 print:pt-0">
      <p class="font-bold">{{ campaign.fullAddress }}</p>
      @if (campaign.salePrice) {
        <div class="my-1">{{ campaign.salePrice | currency: undefined : 'symbol' : '1.0' }}</div>
      }
      @if (campaign.leaseMaxPrice) {
        <div class="my-1">{{ campaign.leaseMaxPrice | currency: undefined : 'symbol' : '1.0' }}/{{ campaign.leasePeriod }}</div>
      }
      <rma-property-attribute
        class="mb-3 text-steel-70 print:mb-1"
        [bathrooms]="campaign.bathrooms"
        [bedrooms]="campaign.bedrooms"
        [carparks]="campaign.carparks"
        [landSize]="campaign.landSize"
        [houseSize]="campaign.houseSize"
        [propertyType]="campaign.propertyType"
      />
      @if (campaign.listedDate || campaign.saleDate || campaign.salePrice || campaign.leaseMaxPrice) {
        <hr class="my-3 mt-auto text-steel-20 print:hidden" />
      }
      @if (campaign.saleDate) {
        <div>{{ campaign.saleMethod | transloco }} on {{ campaign.saleDate | date: 'dd MMM yyyy' }}</div>
      }
    </div>
  }
</ng-container>
